import { createUseStyles } from 'react-jss'
import { WHITE_23, BLUE_25, DARK_GRAY_11, BRIGHT_BLUE } from '@omnilert/components'

export default createUseStyles({
  switchContainer: {
    display: 'inline-block',
    height: '32px',
    position: 'relative',
    width: '53px',
    '& input': {
      '&:checked + span:before': {
        backgroundColor: BRIGHT_BLUE,
        transform: 'translateX(21px)',
        boxShadow: `0px 4px 15px ${BLUE_25}, 0px 2px 4px ${DARK_GRAY_11}, inset 0px 0px 0px ${WHITE_23}`
      },
      height: '0',
      opacity: '0',
      width: '0'
    }
  },
  switchSlider: {
    '&:before': {
      backgroundColor: 'var(--form__switch__dial__background__color)',
      borderRadius: '50%',
      bottom: '2px',
      content: '""',
      height: '28px',
      left: '2px',
      position: 'absolute',
      transition: '.4s',
      WebkitTransition: '.4s',
      width: '28px'
    },
    backgroundColor: ({ checked }) => checked ? 'var(--form__switch__checked__background__color)' : 'var(--form__switch__unchecked__background__color)',
    borderRadius: '34px',
    bottom: '0',
    cursor: 'pointer',
    left: '0',
    position: 'absolute',
    right: '0',
    top: '0',
    transition: '.4s'
  }
})
